export type ModalTeleportTarget = string | HTMLElement;

export function resolveModalTeleportTarget(element: any)
{
    const dialog = element?.closest('dialog') as HTMLElement | null;

    if (dialog)
    {
        return dialog.querySelector(':scope > [data-ideo-modal-teleport-target]') as HTMLElement || dialog;
    }

    return element?.closest('[data-ideo-mobile-sheet-teleport-target]') as HTMLElement || 'body';
}
